<template>
	<div class="personal-box content">
		<div class="center-box flex-row">
<!--			<div class="box-left">-->
<!--				<div class="list-box" v-for="(pages, index) in lists" :key="index">-->

<!--					<div class="list" @click="changeView(item.url)" :class="activeLabel == item.label ? 'active '+item.class : item.class" v-for="(item, idx) in pages" :key="idx+index">-->
<!--						<i :class="item.icon" style="margin-right: 10px;font-size: 18px;color:#32644a" v-if="idx == 0" />-->
<!--						<span>{{item.label}}</span>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
			<div class="main-box">
				<slot></slot>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'personal',
		props: ['activeLabel'],
		data() {
			return {
				lists: [
					[{
							label: '个人中心',
							class: 'title',
							url: '/personalCenter/index',
							icon:'el-icon-s-custom'
						},
						{
							label: '个人资料',
							class: '',
							url: '/personalCenter/index',
							icon: ''
						},
						{
							label: '密码管理',
							class: '',
							url: '/personalCenter/password',
							icon: ''
						},
					],
					[{
							label: '订单管理',
							class: 'title',
							url: '/personalCenter/orderDevice',
							icon: 'el-icon-s-order'
						},
						// {
						// 	label: '成套设备租赁',
						// 	class: '',
						// 	url: '/personalCenter/orderDevice'
						// },
						// {
						// 	label: '应急保电',
						// 	class: '',
						// 	url: '/personalCenter/orderPower'
						// },
						// {
						// 	label: '共享电工',
						// 	class: '',
						// 	url: '/personalCenter/orderShare'
						// },
					],
					[{
						label: '留言列表',
						class: 'title',
						url: '/personalCenter/leaveMessage',
						icon: 'el-icon-message-solid'
					}]
				]
			}
		},
		methods: {
			changeView(url) {
				if (!url) return;
				this.$router.push({
					path: url
				})
			}
		}
	}
</script>
<style lang="less" scoped>
	.personal-box {
		background: #F5F5F5;
		padding: 0.2rem 0 1.63rem;

		.center-box {
			width: 17.33rem;
			margin: 0 auto;
			align-items: flex-start;
		}

		.box-left {
			width: 2.57rem;
			min-width: 2.57rem;
			height: 7rem;
			margin-right: .18rem;

			.list-box {
				background: #FFF;
				margin-bottom: 12px;
				border-radius: 6px;

				.list {
					height: 0.5rem;
					padding-left: 85px;
					position: relative;
					font-size: .14rem;
					line-height: 0.5rem;
					color: #616161;
					font-weight: 500;
					cursor: pointer;
					&.active {
						background: #ffffe9;
						color: #b05347;
					}

					&.title {
						color: #333;
						padding-left: 60px;
					}
				}
			}
		}

		// 主要页面
		.main-box {
			flex: 1;
			background: #FFF;
			border-radius: 0.06rem;
		}
	}
</style>
